import { createGlobalStyle } from "styled-components";


  
export const Styles = createGlobalStyle`

    @font-face {
        font-family: 'Inter';
        src: url('./fonts/Inter_24pt-Regular.ttf') format('truetype');
        font-weight: normal;
        font-style: normal;
    }

    body,
    html,
    a {
        font-family: 'Inter', sans-serif;
    }


    body, html {
        margin:0;
        padding:0;
        border: 0;
        outline: 0;
        background: var(--deepco-surface-white);
        overflow-x: hidden;
    }

    a:hover {
        color: var(--deepco-legacy-link);
    }

    input,
    textarea {
        border-radius: 4px;
        border: 0;
        background: rgb(241, 242, 243);
        transition: all 0.3s ease-in-out;  
        outline: none;
        width: 100%;  
        padding: 1rem 1.25rem;

        :focus-within {
            background: none;
            box-shadow: var(--deepco-legacy-focus) 0px 0px 0px 1px;
        }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: Inter, sans-serif;
        color: var(--deepco-surface-black);
        font-size: 56px;
        line-height: 1.18;

        @media only screen and (max-width: 890px) {
          font-size: 47px;
        }
      
        @media only screen and (max-width: 414px) {
          font-size: 32px;
        }
    }

    p {
        color: var(--deepco-surface-black)00;
        font-size: 21px;        
        line-height: 1.41;
    }

    h1 {
        font-weight: 600;
    }

    a {
        text-decoration: none;
        outline: none;
        color: var(--deepco-surface-black);

        :hover {
            color: var(--deepco-legacy-focus);
        }
    }
    
    *:focus {
        outline: none;
    }

    .about-block-image svg {
        text-align: center;
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-top: 1.5rem;
    }

    .ant-drawer-content-wrapper {
        width: 300px !important;
    }
    .scrollbar-hide {
    -ms-overflow-style: none;  /* IE 10+ */
    scrollbar-width: none;     /* Firefox */
    }
    .scrollbar-hide::-webkit-scrollbar {
    display: none;             /* Chrome, Safari, Edge */
    }

`;

